"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable @typescript-eslint/no-loop-func */
/* eslint-disable import/no-unresolved */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable consistent-return */
/* eslint-disable max-len */
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const sdk_1 = __importDefault(require("@twa-dev/sdk"));
const react_i18next_1 = require("react-i18next");
const de_ui_1 = require("@delab-team/de-ui");
const validatorus_react_1 = require("validatorus-react");
const uuid_1 = require("uuid");
const stores_1 = require("../../stores");
const wallet_1 = require("../../logic/wallet");
const privacy_1 = require("./privacy");
const svg_selector_1 = require("../../assets/svg-selector");
const settings_module_css_1 = __importDefault(require("./settings.module.css"));
const pinpad_1 = require("../../components/pinpad");
const getClient_1 = require("../../utils/getClient");
async function delay(ms) {
    // eslint-disable-next-line no-promise-executor-return
    return new Promise(resolve => setTimeout(resolve, ms));
}
const Settings = (props) => {
    const [position, setPosition] = (0, react_1.useState)(0);
    const [privateKey, setPrivateKey] = (0, react_1.useState)(undefined);
    const [createAnimation, setCreateAnimation] = (0, react_1.useState)(undefined);
    // change password (pincode to pincode)
    const [createAnimation1, setCreateAnimation1] = (0, react_1.useState)(undefined);
    const [createAnimation2, setCreateAnimation2] = (0, react_1.useState)(undefined);
    const [createAnimation3, setCreateAnimation3] = (0, react_1.useState)(undefined);
    const [recoveryWords, setRecoveryWords] = (0, react_1.useState)(undefined);
    const [isCopiedAddress, setIsCopiedAddress] = (0, react_1.useState)(false);
    const [isCopiedPrivateKey, setIsCopiedPrivateKey] = (0, react_1.useState)(false);
    const [isCopiedRecovery, setIsCopiedRecovery] = (0, react_1.useState)(false);
    const [currentChangeVersion, setCurrentChangeVersion] = (0, react_1.useState)(undefined);
    const [recoveryWordsChange, setRecoveryWordsChange] = (0, react_1.useState)(undefined);
    const [positionChange, setPositionChange] = (0, react_1.useState)(0);
    const oldPassword = new validatorus_react_1.VldBuilder()
        .with(validatorus_react_1.vlds.VNumber)
        .with(validatorus_react_1.vlds.VLen, 4, 4)
        .withFname('New Password');
    const newPassword = new validatorus_react_1.VldBuilder()
        .with(validatorus_react_1.vlds.VNumber)
        .with(validatorus_react_1.vlds.VLen, 4, 4)
        .withFname('New Password');
    const newPasswordRepeat = new validatorus_react_1.VldBuilder()
        .with(validatorus_react_1.vlds.VNumber)
        .with(validatorus_react_1.vlds.VLen, 4, 4)
        .withFname('New Password');
    const TgObj = sdk_1.default;
    const { storeMain } = (0, stores_1.useStores)();
    const wallet = new wallet_1.CustomWallet((0, getClient_1.getDeLabClient)());
    const { t } = (0, react_i18next_1.useTranslation)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const [walletVersion, setWalletVersion] = (0, react_1.useState)(undefined);
    const handleCloseModal = () => {
        setPrivateKey('');
        setRecoveryWords([]);
        TgObj.MainButton.hide();
        TgObj.BackButton.hide();
        navigate('/');
    };
    const psw = new validatorus_react_1.VldBuilder().with(validatorus_react_1.vlds.VLen, 8, 160).withFname('Password');
    const handleBackClick = () => {
        TgObj.HapticFeedback.impactOccurred('medium');
        if (position === 0) {
            TgObj.BackButton.show();
            handleCloseModal();
            TgObj.MainButton.hide();
        }
        else if (position === 8) {
            if (positionChange === 0) {
                oldPassword.reset(true, true);
                newPassword.reset(true, true);
                newPasswordRepeat.reset(true, true);
                setPosition(0);
                TgObj.MainButton.hide();
            }
            if (positionChange === 1) {
                newPassword.reset(true, true);
                newPasswordRepeat.reset(true, true);
                setPositionChange(0);
            }
            if (positionChange === 2) {
                newPasswordRepeat.reset(true, true);
                setPositionChange(0);
            }
        }
        else {
            psw.reset(true, true);
            setPosition(0);
            TgObj.MainButton.hide();
        }
    };
    (0, react_1.useLayoutEffect)(() => {
        const checkPincode = async () => {
            const isPinCode = await wallet.isPincodPassword();
            if (!isPinCode) {
                navigate('/changepsw');
            }
        };
        checkPincode();
    });
    async function getPrivateKey() {
        const res = await wallet.getPrivateKeyHex(psw.value);
        if (typeof res === 'object') {
            setCreateAnimation('failure');
            await delay(300);
            return;
            //  alert(t('common.incorrect-password'))
        }
        setCreateAnimation('success');
        await delay(280);
        setPosition(3);
        setCreateAnimation(undefined);
        psw.reset(true, true);
        setPrivateKey(res?.toString());
    }
    async function getPrivateKey2() {
        const res = await wallet.getPrivateKeys(psw.value);
        if (typeof res === 'object') {
            setCreateAnimation('failure');
            await delay(300);
            return;
            // alert(t('common.incorrect-password'))
        }
        setCreateAnimation('success');
        await delay(280);
        setPosition(4);
        setCreateAnimation(undefined);
        psw.reset(true, true);
        setRecoveryWords(res?.split(' '));
    }
    const setVersion = async (vers) => {
        console.log('START UPDATE VERSION');
        const res = wallet.saveVersion({ version: vers });
        const res2 = await wallet.changeVersionAddres(vers);
        console.log('saveVersion result', res);
        console.log('changeVersionAddres result', res2);
    };
    (0, react_1.useEffect)(() => {
        const initVersion = async () => {
            try {
                const loadData = await wallet.loadVersionSaveData();
                console.log('loadData', loadData);
                if (loadData.version) {
                    setWalletVersion(loadData.version);
                }
            }
            catch (error) {
                console.error('Error during data retrieval:', error);
            }
        };
        initVersion();
    }, []);
    (0, react_1.useLayoutEffect)(() => {
        window.document.body.scrollTo(0, 0);
    }, []);
    (0, react_1.useEffect)(() => {
        if (position !== 0) {
            storeMain.setShowNavigation(false);
        }
        if (position === 0) {
            storeMain.setShowNavigation(true);
        }
    }, [position]);
    (0, react_1.useEffect)(() => {
        if (position !== 0) {
            storeMain.setShowNavigation(false);
        }
        if (position === 0) {
            storeMain.setShowNavigation(true);
        }
    }, [position]);
    const setVersionHandler = async () => {
        if (!currentChangeVersion) {
            return;
        }
        const res = await wallet.getPrivateKeys(psw.value);
        if (typeof res === 'object') {
            setCreateAnimation('failure');
            await delay(300);
            return;
            // alert(t('common.incorrect-password'))
        }
        setWalletVersion(currentChangeVersion);
        setVersion(currentChangeVersion);
        setCreateAnimation('success');
        await delay(280);
        setPosition(0);
        await delay(2000);
        setCreateAnimation(undefined);
        window.location.reload();
    };
    console.log(currentChangeVersion);
    const setVersionPosition = (vers) => {
        setPosition(10);
        setCurrentChangeVersion(vers);
    };
    // function enableBtn () {
    //     TgObj.MainButton.show()
    //     TgObj.MainButton.text = textBtn
    //     if (!psw.value || psw.value.length < 8) {
    //         TgObj.MainButton.disable()
    //         TgObj.MainButton.color = '#424B56'
    //     } else if (position === 5) {
    //         TgObj.MainButton.enable()
    //         TgObj.MainButton.color = '#FF1C45'
    //     } else {
    //         TgObj.MainButton.enable()
    //         TgObj.MainButton.color = '#007AFF'
    //     }
    // }
    (0, react_1.useEffect)(() => {
        TgObj.BackButton.show();
        TgObj.BackButton.onClick(handleBackClick);
        return () => {
            TgObj.BackButton.offClick(handleBackClick);
        };
    }, [position, positionChange]);
    async function AccountToDelete() {
        const res = await wallet.delWallet(psw.value);
        if (!res) {
            // TgObj.showAlert('Incorrect password')
            setCreateAnimation('failure');
            await delay(300);
            return;
        }
        setCreateAnimation('success');
        await delay(280);
        props.deletedAccount(psw.value);
        setCreateAnimation(undefined);
    }
    (0, react_1.useEffect)(() => {
        TgObj.BackButton.show();
        if (position !== 1 && position !== 2 && position !== 5 && position !== 10) {
            TgObj.MainButton.hide();
            return;
        }
        if (position === 1 && psw.value.length === 4) {
            getPrivateKey();
        }
        if (position === 2 && psw.value.length === 4) {
            getPrivateKey2();
        }
        if (position === 5 && psw.value.length === 4) {
            AccountToDelete();
        }
        if (position === 10 && psw.value.length === 4) {
            setVersionHandler();
        }
        // }
    }, [position, psw, psw.value]);
    (0, react_1.useEffect)(() => {
        if (window.location.pathname === '/settings') {
            TgObj.SettingsButton.show();
            TgObj.SettingsButton.onClick(() => setPosition(0));
        }
        TgObj.SettingsButton.offClick(() => setPosition(0));
    }, [window.location.pathname]);
    const handleExit = () => {
        TgObj.HapticFeedback.impactOccurred('medium');
        if (window.confirm(t('common.are-you-sure'))) {
            wallet.exitWallet();
            window.location.pathname = '/reg';
        }
    };
    // switch theme
    const themeHandler = () => {
        storeMain.setIsLightTheme(!storeMain.repository.value?.isLightTheme);
        console.log('handler', storeMain.repository.value?.isLightTheme);
    };
    async function getMnemonic() {
        const res = await wallet.getPrivateKeys(oldPassword.value);
        if (typeof res === 'object') {
            setCreateAnimation1('failure');
            await delay(300);
            return;
            //  alert(t('common.incorrect-password'))
        }
        setRecoveryWordsChange(res?.split(' '));
        setCreateAnimation1('success');
        await delay(280);
        setPositionChange(1);
        oldPassword.reset(true, true);
        setCreateAnimation1(undefined);
    }
    (0, react_1.useEffect)(() => {
        if (oldPassword.value.length === 4) {
            getMnemonic();
        }
    }, [oldPassword, oldPassword.value]);
    (0, react_1.useEffect)(() => {
        const setPincode = async () => {
            if (newPassword.value.length === 4) {
                setCreateAnimation2('success');
                await delay(270);
                setPositionChange(2);
            }
        };
        setPincode();
    }, [newPassword.value]);
    console.log(newPassword.value, 'newPassword');
    console.log(oldPassword.value, 'oldPassword');
    (0, react_1.useEffect)(() => {
        const changePassword = async () => {
            if (newPassword.value === newPasswordRepeat.value && recoveryWordsChange) {
                setCreateAnimation3('success');
                await delay(150);
                const hash = await wallet_1.CustomWallet.KeyToHash(recoveryWordsChange.join(' '), newPasswordRepeat.value);
                const loadData = await wallet.loadHashSaveData();
                console.log('CHANGE WALLET PSW');
                if (!hash || !loadData) {
                    setCreateAnimation3('failure');
                    return;
                }
                // save new hash in storage
                wallet.saveWallet({
                    iv: hash.iv,
                    hashFromKey: hash.hashFromKey,
                    publicKey: loadData.public,
                    address: loadData.address
                });
                // wallet.setIsPincode()
                // window.location.pathname = '/'
                oldPassword.reset(true, true);
                newPassword.reset(true, true);
                newPasswordRepeat.reset(true, true);
                setPositionChange(0);
                setPosition(0);
            }
            else if (newPassword.value !== newPasswordRepeat.value) {
                setCreateAnimation3('failure');
            }
        };
        if (newPasswordRepeat.value.length === 4) {
            changePassword();
        }
    }, [newPasswordRepeat.value]);
    return ((0, jsx_runtime_1.jsxs)("div", { className: `${settings_module_css_1.default.wrapper} ${(position !== 1 && position !== 2 && position !== 5 && position !== 10 && position !== 8) && settings_module_css_1.default.bottomPadding}`, children: [isCopiedAddress && ((0, jsx_runtime_1.jsx)(de_ui_1.Alert, { type: "important", onClose: () => setIsCopiedAddress(false), icon: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "\uD83D\uDCC3" }), autoCloseTimeout: 1000, position: "top-right", className: settings_module_css_1.default.alert, children: t('settings-modal.address-copied') })), isCopiedPrivateKey && ((0, jsx_runtime_1.jsx)(de_ui_1.Alert, { type: "important", onClose: () => setIsCopiedPrivateKey(false), icon: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "\uD83D\uDCC3" }), autoCloseTimeout: 1000, position: "top-right", className: settings_module_css_1.default.alert, children: t('settings-modal.recovery-copied') })), isCopiedRecovery && ((0, jsx_runtime_1.jsx)(de_ui_1.Alert, { type: "important", onClose: () => setIsCopiedRecovery(false), icon: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "\uD83D\uDCC3" }), autoCloseTimeout: 1000, position: "top-right", className: settings_module_css_1.default.alert, children: t('settings-modal.recovery-words') })), (0, jsx_runtime_1.jsxs)(de_ui_1.Div, { className: `${settings_module_css_1.default.modal} ${(position !== 1 && position !== 2 && position !== 5 && position !== 10 && position !== 8) && settings_module_css_1.default.paddingsModal}`, children: [position === 0 && ((0, jsx_runtime_1.jsx)("div", { className: settings_module_css_1.default.info, children: (0, jsx_runtime_1.jsxs)("div", { className: settings_module_css_1.default.actions, children: [(0, jsx_runtime_1.jsxs)(de_ui_1.Title, { variant: "h3", className: settings_module_css_1.default.actionsTitle, children: [(0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "settings2" }), " ", t('settings-modal.settings-title')] }), (0, jsx_runtime_1.jsxs)(de_ui_1.Div, { className: settings_module_css_1.default.actionsInner, children: [(0, jsx_runtime_1.jsxs)(de_ui_1.Button, { className: settings_module_css_1.default.action, onClick: () => {
                                                TgObj.HapticFeedback.impactOccurred('medium');
                                                setPosition(1);
                                            }, children: [t('settings-modal.show-private-key'), (0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "arrow-right-2" })] }), (0, jsx_runtime_1.jsxs)(de_ui_1.Button, { className: settings_module_css_1.default.action, onClick: () => {
                                                TgObj.HapticFeedback.impactOccurred('medium');
                                                setPosition(2);
                                            }, children: [t('settings-modal.show-recovery-phrase'), (0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "arrow-right-2" })] }), (0, jsx_runtime_1.jsxs)(de_ui_1.Button, { className: settings_module_css_1.default.action, onClick: () => {
                                                TgObj.HapticFeedback.impactOccurred('medium');
                                                setPosition(8);
                                            }, children: [t('common.change-psw'), (0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "arrow-right-2" })] }), (0, jsx_runtime_1.jsxs)(de_ui_1.Button, { className: settings_module_css_1.default.action, onClick: () => {
                                                TgObj.HapticFeedback.impactOccurred('medium');
                                                setPosition(6);
                                            }, children: [t('common.privacy'), (0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "arrow-right-2" })] }), (0, jsx_runtime_1.jsxs)(de_ui_1.Button, { className: `${settings_module_css_1.default.action} ${settings_module_css_1.default.actionDanger}`, onClick: () => {
                                                TgObj.HapticFeedback.impactOccurred('medium');
                                                setPosition(5);
                                            }, children: [t('settings-modal.delete-account'), (0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "arrow-right-2" })] }), (0, jsx_runtime_1.jsxs)(de_ui_1.Button, { className: `${settings_module_css_1.default.action} ${settings_module_css_1.default.actionDanger}`, onClick: handleExit, children: [t('settings-modal.exit'), (0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "arrow-right-2" })] })] }), (0, jsx_runtime_1.jsxs)(de_ui_1.Title, { variant: "h3", className: settings_module_css_1.default.actionsTitle, children: [(0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "language" }), " ", t('settings-modal.language')] }), (0, jsx_runtime_1.jsxs)(de_ui_1.Div, { className: settings_module_css_1.default.actionsInner, children: [(0, jsx_runtime_1.jsxs)(de_ui_1.Button, { className: `${settings_module_css_1.default.action}`, onClick: () => {
                                                TgObj.HapticFeedback.impactOccurred('medium');
                                                props.setSelectedLanguage('ru');
                                            }, children: [t('settings-modal.russian'), props.selectedLanguage === 'ru' && (0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "checked-2" })] }), (0, jsx_runtime_1.jsxs)(de_ui_1.Button, { className: `${settings_module_css_1.default.action}`, onClick: () => {
                                                TgObj.HapticFeedback.impactOccurred('medium');
                                                props.setSelectedLanguage('en');
                                            }, children: [t('settings-modal.english'), props.selectedLanguage === 'en' && (0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "checked-2" })] })] }), (0, jsx_runtime_1.jsxs)(de_ui_1.Title, { variant: "h3", className: settings_module_css_1.default.actionsTitle, children: [(0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "version" }), " ", t('settings-modal.version')] }), (0, jsx_runtime_1.jsxs)(de_ui_1.Div, { className: settings_module_css_1.default.actionsInner, children: [(0, jsx_runtime_1.jsxs)(de_ui_1.Button, { className: `${settings_module_css_1.default.action}`, onClick: () => {
                                                TgObj.HapticFeedback.impactOccurred('medium');
                                                setVersionPosition('V4');
                                            }, children: ["Wallet V4", walletVersion === 'V4' && (0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "checked-2" })] }), (0, jsx_runtime_1.jsxs)(de_ui_1.Button, { className: `${settings_module_css_1.default.action}`, onClick: () => {
                                                TgObj.HapticFeedback.impactOccurred('medium');
                                                setVersionPosition('V3R1');
                                            }, children: ["Wallet V3R1", walletVersion === 'V3R1' && (0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "checked-2" })] }), (0, jsx_runtime_1.jsxs)(de_ui_1.Button, { className: `${settings_module_css_1.default.action}`, onClick: () => {
                                                TgObj.HapticFeedback.impactOccurred('medium');
                                                setVersionPosition('V3R2');
                                            }, children: ["Wallet V3R2", walletVersion === 'V3R2' && (0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "checked-2" })] })] }), (0, jsx_runtime_1.jsxs)(de_ui_1.Title, { variant: "h3", className: settings_module_css_1.default.actionsTitle, children: [(0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "earth" }), " DeWallet, 2024"] }), (0, jsx_runtime_1.jsxs)(de_ui_1.Div, { className: settings_module_css_1.default.actionsInner, children: [(0, jsx_runtime_1.jsxs)(react_router_dom_1.Link, { to: "https://t.me/delabsupportbot", target: "_blank", className: settings_module_css_1.default.action, children: ["DeLab ", t('common.support'), (0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "link" })] }), (0, jsx_runtime_1.jsxs)(react_router_dom_1.Link, { to: "https://t.me/delab", target: "_blank", className: settings_module_css_1.default.action, children: ["Telegram", (0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "link" })] }), (0, jsx_runtime_1.jsxs)(react_router_dom_1.Link, { to: "https://github.com/delab-team", target: "_blank", className: settings_module_css_1.default.action, children: ["GitHub", (0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "link" })] })] })] }) })), (position === 1 || position === 2 || position === 5 || position === 10) && ((0, jsx_runtime_1.jsx)(pinpad_1.PinPad, { title: t('pincod.enter'), onChange: e => psw.change(e), animationState: createAnimation, setAnimationState: setCreateAnimation })), (position === 8) && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(positionChange === 0)
                                && (0, jsx_runtime_1.jsx)(pinpad_1.PinPad, { title: t('pincod.old'), onChange: e => oldPassword.change(e), animationState: createAnimation1, setAnimationState: setCreateAnimation1 }), (positionChange === 1)
                                && (0, jsx_runtime_1.jsx)(pinpad_1.PinPad, { title: t('pincod.create'), onChange: e => newPassword.change(e), animationState: createAnimation2, setAnimationState: setCreateAnimation2 }), (positionChange === 2)
                                && (0, jsx_runtime_1.jsx)(pinpad_1.PinPad, { title: t('pincod.repeat'), onChange: e => newPasswordRepeat.change(e), animationState: createAnimation3, setAnimationState: setCreateAnimation3 })] })), position === 3 ? ((0, jsx_runtime_1.jsx)("div", { className: `${settings_module_css_1.default.privateInfo} ${settings_module_css_1.default.privateInfoWords}`, children: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", { className: settings_module_css_1.default.privateAlertInfo, children: t('settings-modal.private-key-info') }), (0, jsx_runtime_1.jsxs)(de_ui_1.Div, { className: settings_module_css_1.default.privateInfoKey, children: [(0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: settings_module_css_1.default.privateKetText, children: privateKey }), (0, jsx_runtime_1.jsx)("div", { className: settings_module_css_1.default.line }), (0, jsx_runtime_1.jsxs)(de_ui_1.Button, { className: settings_module_css_1.default.btnCopy, onClick: async () => {
                                                TgObj.HapticFeedback.impactOccurred('medium');
                                                if (privateKey) {
                                                    try {
                                                        await navigator.clipboard.writeText(privateKey);
                                                        setIsCopiedPrivateKey(true);
                                                    }
                                                    catch (err) {
                                                        console.error('Unable to copy privateKey', err);
                                                    }
                                                }
                                            }, children: [(0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "copy-2" }), t('common.copy')] })] })] }) })) : null, position === 4 ? ((0, jsx_runtime_1.jsx)("div", { className: settings_module_css_1.default.privateInfo, children: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("div", { className: settings_module_css_1.default.privateAlertInfo, children: [t('settings-modal.recovery-info'), " "] }), (0, jsx_runtime_1.jsxs)("div", { className: settings_module_css_1.default.recoveryWordsWrapper, children: [(0, jsx_runtime_1.jsx)("div", { className: settings_module_css_1.default.recoveryWords, children: recoveryWords?.map((el, key) => ((0, jsx_runtime_1.jsx)(de_ui_1.Button, { onClick: async () => {
                                                    TgObj.HapticFeedback.impactOccurred('medium');
                                                    try {
                                                        await navigator.clipboard.writeText(el);
                                                    }
                                                    catch (err) {
                                                        console.error(`Unable to copy recovery word ${el}`, err);
                                                    }
                                                }, className: settings_module_css_1.default.recoveryWord, style: { display: el.length > 1 ? '' : 'none' }, children: (0, jsx_runtime_1.jsxs)(de_ui_1.Text, { className: settings_module_css_1.default.word, children: [key + 1, ". ", el] }) }, (0, uuid_1.v1)()))) }), (0, jsx_runtime_1.jsx)("div", { className: settings_module_css_1.default.line }), (0, jsx_runtime_1.jsxs)(de_ui_1.Button, { className: settings_module_css_1.default.btnCopy, onClick: async () => {
                                                TgObj.HapticFeedback.impactOccurred('medium');
                                                if (recoveryWords) {
                                                    try {
                                                        await navigator.clipboard.writeText(recoveryWords.join(' '));
                                                        setIsCopiedPrivateKey(true);
                                                    }
                                                    catch (err) {
                                                        console.error('Unable to copy recovery words', err);
                                                    }
                                                }
                                            }, children: [(0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "copy-2" }), t('common.copy')] })] })] }) })) : null, position === 6 ? ((0, jsx_runtime_1.jsx)(privacy_1.Privacy, {})) : null] })] }));
};
// eslint-disable-next-line import/no-default-export
exports.default = Settings;
